import { createSlice } from "@reduxjs/toolkit";

const initialStateList = {
  selectedStudent: {},
  allStudents: [],
  allStudentsLoaded: false,
};

const appSlice = createSlice({
  name: "app",
  initialState: initialStateList,
  reducers: {
    setSelectedStudent: (state, action) => {
      state.selectedStudent = action.payload;
    },
    setAllStudents: (state, action) => {
      state.allStudents = action.payload;
      state.allStudentsLoaded = true;
    },
    updateStudentArchive: (state, action) => {
      const { studentId, loanTypes } = action.payload;
      const idx = state.allStudents.findIndex(
        (s) => s.student_id === studentId
      );
      if (idx !== -1) {
        state.allStudents[idx] = {
          ...state.allStudents[idx],
          loan_types: loanTypes,
        };
      }
    },
    updateStudentField: (state, action) => {
      const { studentId, fields } = action.payload;
      const idx = state.allStudents.findIndex(
        (s) => s.student_id === studentId
      );
      if (idx !== -1) {
        state.allStudents[idx] = { ...state.allStudents[idx], ...fields };
      }
    },
  },
});

export const {
  setSelectedStudent,
  setAllStudents,
  updateStudentArchive,
  updateStudentField,
} = appSlice.actions;

export default appSlice.reducer;
